import React, { Fragment } from 'react';
import { Flex, Box, Button, Text, Card } from 'rebass';
import { compose, withApollo } from 'react-apollo';
import { withWizard } from 'react-albus';
import { withToastManager } from 'react-toast-notifications';

import withSession from '../../lib/withSession';
import { bounceIn } from '../../utils/animationsStyleBuilder';

const Disclaimer = ({ data, wizard }) => {
  return (
    <Fragment>
      <Flex justifyContent="center" style={{ zIndex: 1 }}>
        <Flex width="600px" p={3}>
          <Card style={{ ...bounceIn() }}>
            <Flex flexDirection="column">
              <Box p={2} pt={4}>
                <Text fontSize={'20px'} fontWeight={400} color="#344f77" textAlign="center">
                  {data.title}
                </Text>
              </Box>

              <Box p={3} alignSelf="center">
                <Text lineHeight={1.6} textAlign="center">
                  {data.prompt}
                </Text>
              </Box>
            </Flex>

            <Flex alignItems="center" flexDirection="column" p={3}>
              <Button type="button" variant="pink" width={[1, 1 / 2]} mb={3} onClick={() => wizard.next()}>
                {data.buttonText || 'I understand'}
              </Button>
            </Flex>
          </Card>
        </Flex>
      </Flex>
    </Fragment>
  );
};

export default compose(
  withApollo,
  withWizard,
  withToastManager,
  withSession
)(Disclaimer);
